import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface VendorsTableProps {
}

export const VendorsTable: React.FC<VendorsTableProps> = () => {

    const vendorsState = useAppSelector(state => state.vendors);

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Ettevõte</th>
                <th>Kommentaar</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {vendorsState.vendors.map(row => {

                const rowClass = (row.banned_at) ? 'reclamation' : '';

                return (
                    <tr className={rowClass}>
                        <td>
                            {row.name}
                        </td>
                        <td>
                            {row.comment}
                        </td>
                        <td className="action">
                            <Link to={`/vendors/${row.id}/contacts`}>Kontaktid</Link>
                            <span>|</span>
                            <Link to={`/vendors/${row.id}/modify`}>Muuda</Link>
                            <span>|</span>
                            <Link to={`/vendors/${row.id}/delete`}>Kustuta</Link>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    );

}